





















export default {
  name: 'WizardTitleDecorationIcon.vue',
  props: {
    color: {
      type: String,
      default: '#00ffdc'
    }
  }
}
